import { useCallback, useEffect, useRef, useState } from 'react';

import { RefundFilesApi } from '@/api/clients/refund-files/refund-files.api';

const useGetRefundFiles = ({
  organizationId,
  facilityId,
  fileStatus,
  page,
  limit,
}) => {
  const [files, setFiles] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const latestRequestId = useRef(0);

  const fetchRefundFiles = useCallback(async () => {
    const requestId = ++latestRequestId.current;
    const isStale = () => requestId !== latestRequestId.current;

    setLoading(true);
    try {
      const response = await RefundFilesApi.getAdminRefundFiles({
        organizationId,
        facilityId,
        fileStatus,
        page,
        limit,
      });
      if (isStale()) {
        return;
      }
      setFiles(response.data?.data ?? []);
      setTotalCount(response.data?.pagination?.total ?? 0);
    } catch (err) {
      console.log(err);
      if (isStale()) {
        return;
      }
      setFiles([]);
      setTotalCount(0);
    } finally {
      if (!isStale()) {
        setLoading(false);
      }
    }
  }, [organizationId, facilityId, fileStatus, page, limit]);

  const latestFetch = useRef(fetchRefundFiles);
  latestFetch.current = fetchRefundFiles;

  const refetch = useCallback(() => latestFetch.current(), []);

  useEffect(() => {
    fetchRefundFiles();
  }, [fetchRefundFiles]);

  return { files, totalCount, loading, refetch };
};

export default useGetRefundFiles;
